















import UserRequired from "../UserRequired";
import {Component, Prop} from "vue-property-decorator";
import {NotificationConfig} from "@/modules/notificationmodels";

@Component
export default class NotificationConfigToEdit extends UserRequired {
  @Prop()
  config!: NotificationConfig;

  @Prop({default: false})
  value!: boolean;

  get opened() {
    return this.value;
  }
  set opened(v: boolean) {
    this.$emit("input", v);
  }

  get recipientListing() {
    return this.user.emailAddresses;
  }

  emitSave() {
    this.$emit("at-notif-config-do-save", this.config);
  }
}
